import Block from "@components/block"
import guestsAppImg from "@imagesgz/content/guests-app.png"
import guestsPcImg from "@imagesgz/content/guests-pc.png"
import guestTitleAppImg from "@imagesgz/title-guests-app.png"
import guestTitleImg from "@imagesgz/title-guests.png"
import ResponsiveImage from "@src/components/responsiveContent/image"
import React from "react"

const Guests = () => {
  return (
    <Block id="guests" title={[guestTitleImg, guestTitleAppImg]}>
      <ResponsiveImage pc={guestsPcImg} mobile={guestsAppImg} />
    </Block>
  )
}

export default Guests
